export default "__VITE_ASSET__B4Ecl53N__"